module.exports = __webpack_public_path__ + "static/media/mocorito.dd45ac28.jpeg";